<template>
  <div class="section container">
    <h1 class="title is-4">
      {{ $t("student module settings") }}
    </h1>

    <div class="columns">
      <div class="column">
        <div class="title is-5">{{ $t("account module integration") }}</div>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_student_has_account"
            name="chk_every_student_has_account"
            v-model="meta.every_student_has_account"
          />
          <label for="chk_every_student_has_account">{{
            $t("every student has an account")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_student_account_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('account type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="account_type_changed"
            ref="account_type_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="title is-5">{{ $t("modul user integration") }}</div>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_student_has_user"
            name="chk_every_student_has_user"
            v-model="meta.every_student_has_user"
          />
          <label for="chk_every_student_has_user">{{
            $t("every student has a user")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_student_user_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('user role')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/access/role/catalog"
            name_field="name"
            value_field="role_id"
            @selected="role_changed"
            ref="role_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="periods"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="student icon" aria-hidden="true"></i>
            <span>{{ $t("periods") }}</span>
          </a>
        </li>
        <li data-tab="programs" @click="change_active_tab($event, this)">
          <a>
            <i class="student icon" aria-hidden="true"></i>
            <span>{{ $t("programs") }}</span>
          </a>
        </li>
        <li data-tab="stages" @click="change_active_tab($event, this)">
          <a>
            <i class="list icon" aria-hidden="true"></i>
            <span>{{ $t("stages") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="is-active" data-tab="periods"><period-datatable /></div>
      <div class="is-hidden" data-tab="programs"><program-datatable /></div>
      <div class="is-hidden" data-tab="stages"><stage-datatable /></div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  change_active_tab,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import StageDatatable from "./stage_datatable/Index.vue";
import ProgramDatatable from "./program_datatable/Index.vue";
import PeriodDatatable from "./period_datatable/Index.vue";

export default {
  name: "StudentSettings",
  components: {
    GenericDropdown,
    StageDatatable,
    ProgramDatatable,
    PeriodDatatable,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    change_active_tab,
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    check_student_account_existance() {
      let v = this;
      v.$root.loader(true);
      post("/student/account/existance", {
        account_type_id: v.meta.account_type_id,
      })
        .then(() => {
          success_message(v.$t("check finished"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    check_student_user_existance() {
      let v = this;
      v.$root.loader(true);
      post("/student/user-existance", {
        user_role_id: v.meta.user_role_id,
      })
        .then(() => {
          success_message(v.$t("check finished"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    account_type_changed(value) {
      this.meta.account_type_id = value.type_id;
    },
    role_changed(value) {
      this.meta.user_role_id = value.role_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.account_type_id)
            v.$refs.account_type_dropdown.set_value(conf.account_type_id);
          if (conf.user_role_id)
            v.$refs.role_dropdown.set_value(conf.user_role_id);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
